var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.518v4.445m0 0L4.714 8.74M7 10.963L9.286 8.74m1.524 5.926H3.19c-.404 0-.791-.156-1.077-.434a1.461 1.461 0 01-.446-1.048V2.815c0-.393.16-.77.446-1.048a1.546 1.546 0 011.078-.434h4.256c.202 0 .395.078.538.217l4.125 4.01a.73.73 0 01.223.524v7.101c0 .393-.16.77-.446 1.048a1.546 1.546 0 01-1.078.434z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/documentDownload.cca37f7a.svg";
export { SvgDocumentDownload as ReactComponent };